/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_4_Item_ScrapingInputs */

const en_terms_section_4_item_scraping = /** @type {(inputs: Terms_Section_4_Item_ScrapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave automated scraping, data mining and other unauthorised collection alone.`)
};

const lv_terms_section_4_item_scraping = /** @type {(inputs: Terms_Section_4_Item_ScrapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neveikt automatizētu datu izgūšanu vai citu neatļautu datu vākšanu.`)
};

/**
* | output |
* | --- |
* | "Leave automated scraping, data mining and other unauthorised collection alone." |
*
* @param {Terms_Section_4_Item_ScrapingInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_4_item_scraping = /** @type {((inputs?: Terms_Section_4_Item_ScrapingInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_4_Item_ScrapingInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_4_item_scraping(inputs)
	return en_terms_section_4_item_scraping(inputs)
});